import React from 'react'
import { Box, Grid } from '@mui/material'
import PropTypes from 'prop-types'

import StatCell from './StatCell'

function StatContainer({ dataArray }) {
  return (
    <>
      {dataArray.length > 0 && (
        <Box>
          <Grid container spacing={2}>
            {dataArray.map((data) => {
              return (
                <Grid item xs={4} md={12 / dataArray.length} key={data.title}>
                  <StatCell data={data} />
                </Grid>
              )
            })}
          </Grid>
        </Box>
      )}
    </>
  )
}

StatContainer.propTypes = {
  dataArray: PropTypes.array
}

export default StatContainer
